import React, { Component } from 'react';
import cx from 'classnames';
import 'prop-types';
import debounce from 'lodash.debounce';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "._1mXN9{display:inline-block;line-height:0;-webkit-tap-highlight-color:transparent}._1mXN9:not(.MsWLT){cursor:pointer}._1mXN9:focus,.H_JlE:focus{outline:none}.H_JlE{display:flex}._1mXN9:focus ._3F_2i{z-index:2;box-shadow:0 0 0 .125em #8acbff}._3F_2i{position:relative;z-index:1;width:1em;height:1em;flex-shrink:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-sizing:border-box}._3F_2i+._1gOsq{padding-left:.5em}._1mXN9.MsWLT ._3F_2i{cursor:not-allowed}._330O1 ._3F_2i{color:#fff;border-radius:.25em;border:.0625em solid #aaa;background-color:#fff}@media (hover:hover){._330O1:not(.MsWLT) ._3F_2i:hover{border-color:#ff9000}}._330O1:not(.MsWLT):not(._3pkX7) ._3F_2i:active{box-shadow:inset 0 0 .1875em rgba(0,0,0,.25)}._330O1._3pkX7.MsWLT ._3F_2i{background-color:#ffe3bf;border-color:#ffe3bf}._330O1._3pkX7:not(.MsWLT) ._3F_2i{background-color:#ff9000;border-color:#ff9000}@media (hover:hover){._330O1._3pkX7:not(.MsWLT):hover ._3F_2i{background-color:#ffa42e;border-color:#ffa42e}}._330O1._3pkX7:not(.MsWLT):active ._3F_2i{background-color:#f08700;border-color:#f08700}._330O1.MsWLT:not(._3pkX7) ._3F_2i{background-color:#f5f5f5;color:#f5f5f5}";
var styles = {"checkbox":"_1mXN9","is-disabled":"MsWLT","checkbox__body":"H_JlE","checkbox__indicator":"_3F_2i","checkbox__label":"_1gOsq","checkbox--theme--primary":"_330O1","is-checked":"_3pkX7"};
styleInject(css_248z);

var css_248z$1 = "._1fbSL{max-width:100%;font-family:Arial,sans-serif;letter-spacing:.023em;color:inherit;overflow:hidden;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}span._1fbSL{display:inline-block}._1WtBb{color:#fff!important}._4Hy3M{color:#444!important}._3_Myn{color:#888!important}._1D3cy{color:#e74c3c!important}._3dZNm{font-size:.625em}.hACwQ{font-size:.75em}.vZGm3{font-size:.875em}._2hFma{font-size:1em}._13bb-{font-size:1.125em}.ydced{font-size:1.5em}.JUxfc{font-size:1.75em}._18mY0{line-height:100%}._3C_Ah{line-height:120%}._2OzWt{line-height:140%}._19qkj{text-align:left}._3ynq8{text-align:center}._2oIWe{text-align:right}._3CWp9{text-overflow:ellipsis}._1-eRc{text-overflow:clip}._24HIU{text-transform:uppercase}._2TQFr{text-transform:lowercase}._3FPpr{text-transform:capitalize}._2TM2E{white-space:nowrap}._36MxE{white-space:pre}.vZL_u{white-space:pre-line}.kft8W{white-space:pre-wrap}";
var styles$1 = {"text":"_1fbSL","color-white":"_1WtBb","color-tundora":"_4Hy3M","color-gray":"_3_Myn","color-cinnabar":"_1D3cy","font-size-xs":"_3dZNm","font-size-s":"hACwQ","font-size-m":"vZGm3","font-size-l":"_2hFma","font-size-xl":"_13bb-","font-size-2xl":"ydced","font-size-3xl":"JUxfc","line-height-s":"_18mY0","line-height-m":"_3C_Ah","line-height-l":"_2OzWt","text-align-left":"_19qkj","text-align-center":"_3ynq8","text-align-right":"_2oIWe","text-overflow-ellipsis":"_3CWp9","text-overflow-clip":"_1-eRc","text-transform-uppercase":"_24HIU","text-transform-lowercase":"_2TQFr","text-transform-capitalize":"_3FPpr","white-space-nowrap":"_2TM2E","white-space-pre":"_36MxE","white-space-pre-line":"vZL_u","white-space-pre-wrap":"kft8W"};
styleInject(css_248z$1);

var Text = React.memo(function (_ref) {
  var _cx;

  var css = _ref.css,
      tagName = _ref.tagName,
      value = _ref.value;
  var CustomTag = tagName;

  var mergedCSS = _objectSpread2({}, Text.defaultProps.css, {}, css);

  var color = mergedCSS.color,
      fontSize = mergedCSS.fontSize,
      lineHeight = mergedCSS.lineHeight,
      textAlign = mergedCSS.textAlign,
      textOverflow = mergedCSS.textOverflow,
      textTransform = mergedCSS.textTransform,
      whiteSpace = mergedCSS.whiteSpace;
  var componentClassName = cx(styles$1.text, (_cx = {}, _defineProperty(_cx, styles$1["color-".concat(color)], color), _defineProperty(_cx, styles$1["font-size-".concat(fontSize)], fontSize), _defineProperty(_cx, styles$1["line-height-".concat(lineHeight)], lineHeight), _defineProperty(_cx, styles$1["text-align-".concat(textAlign)], textAlign), _defineProperty(_cx, styles$1["text-overflow-".concat(textOverflow)], textOverflow), _defineProperty(_cx, styles$1["text-transform-".concat(textTransform)], textTransform), _defineProperty(_cx, styles$1["white-space-".concat(whiteSpace)], whiteSpace), _cx));
  return /*#__PURE__*/React.createElement(CustomTag, {
    className: componentClassName,
    "data-qa-tag": "text"
  }, value);
});
Text.defaultProps = {
  css: {
    color: null,
    fontSize: 'm',
    lineHeight: 'm',
    textAlign: null,
    textTransform: null,
    whiteSpace: null,
    textOverflow: null
  },
  tagName: 'span'
};

var css_248z$2 = ".GKXR_{display:inline-block;vertical-align:middle;color:inherit;line-height:0;fill:currentColor;pointer-events:none}.GKXR_>svg{width:100%;height:100%}._3JF8I{width:.75em}._1ObA_{width:1em}._1nsfC{width:1.5em}._2BMzL{width:2em}._2FQ3r{width:2.75em}._2t4ti{width:3em}._1BL6S{height:.75em}._2gu2u{height:1em}._2q0cR{height:1.5em}._6uYUY{height:2em}._2_vrk{height:2.75em}._2ntcc{height:3em}";
var styles$2 = {"icon":"GKXR_","width--xs":"_3JF8I","width--s":"_1ObA_","width--m":"_1nsfC","width--l":"_2BMzL","width--xl":"_2FQ3r","width--2xl":"_2t4ti","height--xs":"_1BL6S","height--s":"_2gu2u","height--m":"_2q0cR","height--l":"_6uYUY","height--xl":"_2_vrk","height--2xl":"_2ntcc"};
styleInject(css_248z$2);

var Icon = React.memo(function (_ref) {
  var _cx;

  var css = _ref.css,
      symbol = _ref.symbol;

  var mergedCSS = _objectSpread2({}, Icon.defaultProps.css, {}, css);

  var width = mergedCSS.width,
      height = mergedCSS.height;
  var componentClassName = cx(styles$2.icon, (_cx = {}, _defineProperty(_cx, styles$2["width--".concat(width)], width), _defineProperty(_cx, styles$2["height--".concat(height)], height), _cx));
  return /*#__PURE__*/React.createElement("span", {
    className: componentClassName,
    "aria-hidden": "true"
  }, symbol);
});
Icon.defaultProps = {
  css: {
    width: 's',
    height: 's'
  }
};

var CheckMarkIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      viewBox: "-2 -3 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M3.933 5.519L8.232.359A1 1 0 0 1 9.768 1.64L4.776 7.63a1 1 0 0 1-1.492.068L.293 4.708a1 1 0 0 1 1.414-1.415l2.226 2.226z",
      fillRule: "nonzero"
    }))
  }, props));
});

var DocumentBroken = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "48",
      height: "48",
      viewBox: "-7 0 48 48"
    }, /*#__PURE__*/React.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#D4D4D4",
      d: "M36 9v38a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h26"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#FEFEFE",
      d: "M1 1h26l8 8v38H1z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#D4D4D4",
      fillRule: "nonzero",
      d: "M27 1v8h8l-8-8zm.707-.707l8 8c.63.63.184 1.707-.707 1.707h-8a1 1 0 0 1-1-1V1c0-.89 1.077-1.337 1.707-.707z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#D4D4D4",
      d: "M18 33a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 4c3.642 0 7.118-2.175 9.65-6-2.532-3.825-6.008-6-9.65-6-3.642 0-7.118 2.175-9.65 6 2.532 3.825 6.008 6 9.65 6zm0-14c4.854 0 9.183 3.123 12 8-2.817 4.877-7.146 8-12 8s-9.183-3.123-12-8c2.817-4.877 7.146-8 12-8z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#D4D4D4",
      fillRule: "nonzero",
      d: "M6.293 18.707a1 1 0 0 1 1.414-1.414l22 22a1 1 0 0 1-1.414 1.414l-22-22z"
    })))
  }, props));
});

var DocumentIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "44",
      height: "44",
      viewBox: "-5 0 44 44"
    }, /*#__PURE__*/React.createElement("g", {
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0 2.005C0 .898.897 0 2.005 0h19.99c1.107 0 2.638.633 3.417 1.412l7.176 7.176C33.368 9.368 34 10.892 34 12v30c0 1.105-.892 2-2 2H2c-1.105 0-2-.899-2-2.005V2.005z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#FFF",
      d: "M2 2h20l10 10v30H2z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7 21h20v1H7v-1zm0 3h20v1H7v-1zm0 3h20v1H7v-1zm0 3h10v1H7v-1zm0 3h10v1H7v-1zM22 0l12 12h-9.991A2.01 2.01 0 0 1 22 9.991V0z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#FFF",
      d: "M24 3l7 7h-7z"
    })))
  }, props));
});

var NextIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12",
      viewBox: "-3 -2 20 20"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M5.438 15.609l7.144-6.667a1.272 1.272 0 0 0 0-1.886L5.438.391a1.5 1.5 0 0 0-2.02 0 1.269 1.269 0 0 0 0 1.885L9.551 8l-6.132 5.724a1.27 1.27 0 0 0 0 1.886c.278.26.644.39 1.009.39.366 0 .732-.13 1.01-.391z"
    }))
  }, props));
});

var PagePreviewIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16",
      enableBackground: "new 0 0 16 16"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12,14c0,1.104-0.897,2-2,2H2c-1.103,0-2-0.896-2-2V2c0-1.103,0.897-2,2-2h5c0.818,0,1.172,0,2,1l2,2 c1,1,1,1,1,2H7V2H2v12H12z M16,13.75L14.75,15l-0.625-0.625l-1.854-1.854c-0.088,0.051-0.178,0.099-0.271,0.143l-2,0.302 C8.304,12.722,7,11.264,7,9.5s1.304-3.223,3-3.465C10.163,6.012,10.33,6,10.5,6c0.537,0,1.045,0.121,1.5,0.337 c1.183,0.562,2,1.767,2,3.163c0,0.646-0.175,1.251-0.479,1.771l1.854,1.854L16,13.75z M12,9.5C12,8.672,11.328,8,10.5,8 S9,8.672,9,9.5S9.672,11,10.5,11S12,10.328,12,9.5z"
    }))
  }, props));
});

var PreviousIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12",
      viewBox: "0 -2 20 20"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "rotate(180 8 8)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M5.438 15.609l7.144-6.667a1.272 1.272 0 0 0 0-1.886L5.438.391a1.5 1.5 0 0 0-2.02 0 1.269 1.269 0 0 0 0 1.885L9.551 8l-6.132 5.724a1.27 1.27 0 0 0 0 1.886c.278.26.644.39 1.009.39.366 0 .732-.13 1.01-.391z"
    })))
  }, props));
});

var SpinnerIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: "40px",
      height: "40px",
      viewBox: "0 0 50 50"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#ff9000",
      d: "M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
    }, /*#__PURE__*/React.createElement("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "rotate",
      from: "0 25 25",
      to: "360 25 25",
      dur: "0.6s",
      repeatCount: "indefinite"
    })))
  }, props));
});

var StackIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "-29.5 30.5 16 16"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M-15.5 36.499v7c0 .69-.311 1-1 1h-7c-.689 0-1-.31-1-1v-7c0-.69.311-1 1-1h7c.689 0 1 .31 1 1zm-11 0v7c0 2.071.93 3 3 3h7c2.07 0 3-.929 3-3v-7c0-2.071-.93-3-3-3h-7c-2.07 0-3 .929-3 3zm-1 7v-10c0-.696.366-1 1-1h10c-.518-1.453-1.869-1.999-3.5-1.999h-6.5c-2.071 0-3 .928-3 2.999v7c0 1.631.547 2.483 2 3z"
    }))
  }, props));
});

var CalendarIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "-2 -2 16 16"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "nonzero",
      d: "M9.75.75h.75a1.5 1.5 0 0 1 1.5 1.5v8.25a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 10.5V2.25A1.5 1.5 0 0 1 1.5.75h.75a.75.75 0 1 1 1.5 0h4.5a.75.75 0 1 1 1.5 0zm0 1.5a.75.75 0 1 1-1.5 0h-4.5a.75.75 0 1 1-1.5 0H1.5v8.25h9V2.25h-.75zM1.5 3.75h9v1.5h-9v-1.5zM3 6h1.5v1.5H3V6zm0 2.25h1.5v1.5H3v-1.5zM5.25 6h1.5v1.5h-1.5V6zm0 2.25h1.5v1.5h-1.5v-1.5zM7.5 6H9v1.5H7.5V6zm0 2.25H9v1.5H7.5v-1.5z"
    }))
  }, props));
});

var DownIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "6",
      height: "5"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "nonzero",
      d: "M3 2.44L4.72.72a.75.75 0 0 1 1.06 1.06L3.53 4.03a.75.75 0 0 1-1.06 0L.22 1.78A.75.75 0 0 1 1.28.72L3 2.44z"
    }))
  }, props));
});

var PictureIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "nonzero",
      d: "M14 10V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6.15l2.22-2.775a1 1 0 0 1 1.487-.082L9 9.586l1.293-1.293A1 1 0 0 1 11.6 8.2L14 10zm0 2.5l-2.906-2.18-1.387 1.387a1 1 0 0 1-1.414 0l-3.21-3.21L2 12.351V13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-.5zM3 0h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm7.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
    }))
  }, props));
});

var SignatureIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "nonzero",
      d: "M2.492 10.86a8.792 8.792 0 0 1 .172-1.646c.519-2.605 2.1-4.997 4.996-6.783l.448-.277.827.829 1.153-1.539.18-.068A28.62 28.62 0 0 1 15.202.012a.665.665 0 0 1 .61.194c.149.148.225.365.185.588-.671 3.775-2.097 6.83-3.97 9.122l-.164.201-2.436.348 1.175 1.174-.76.431a8.874 8.874 0 0 1-4.47 1.163c-.52-.006-.992-.063-1.317-.149-.214-.056-.35-.105-.469-.22a9.195 9.195 0 0 0-.003.004c-.337.378-3.265 3.341-3.559 3.12-.16-.12.525-1.196 1.267-2.246L12.363 3.51a.1.1 0 0 0-.13-.153L2.493 10.86z"
    }))
  }, props));
});

var InitialsIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "16"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "nonzero",
      d: "M3.147 2.06c-.85.065-1.414.175-1.657.312A1 1 0 0 1 .51.628C1.305.181 2.753 0 5 0a1 1 0 0 1 .158 1.988C6.905 12.009 5.89 16 2.572 16 .808 16 0 14.516 0 12.111a1 1 0 1 1 2 0C2 13.558 2.24 14 2.572 14c1.484 0 2.18-2.787.588-11.827a1.011 1.011 0 0 1-.013-.113zm10.825 2.714a1 1 0 0 1-1.996-.126c.064-1.018-.003-1.77-.168-2.245-.098-.284-.183-.378-.245-.397-.24-.073-.892.278-1.54 1.025-.742.857-1.249 1.958-1.291 2.832-.041.847.326 1.379 1.304 1.657 3.39.965 4.667 3.696 3.342 6.144-1.275 2.356-4.27 3.13-6.93 1.37a1 1 0 0 1 1.104-1.668c1.674 1.108 3.347.676 4.066-.653.698-1.29.064-2.645-2.13-3.27-1.887-.536-2.84-1.916-2.754-3.677.066-1.362.762-2.87 1.778-4.044C9.62.442 10.944-.271 12.142.092c1.424.43 1.994 2.076 1.83 4.682z"
    }))
  }, props));
});

var HashIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "nonzero",
      d: "M4.523 7.5h2.204l.75-3H5.273l-.75 3zM4.148 9l-.415 1.657a.75.75 0 0 1-1.466-.314L2.602 9H1.5a.75.75 0 1 1 0-1.5h1.477l.75-3H2.25a.75.75 0 1 1 0-1.5h1.852l.415-1.657a.75.75 0 0 1 1.466.314L5.648 3h2.204l.415-1.657a.75.75 0 0 1 1.466.314L9.398 3H10.5a.75.75 0 0 1 0 1.5H9.023l-.75 3H9.75a.75.75 0 0 1 0 1.5H7.898l-.415 1.657a.75.75 0 0 1-1.466-.314L6.352 9H4.148z"
    }))
  }, props));
});

var FormulaIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "12"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "nonzero",
      d: "M9.924 7.125l.81 1.125h.516a.75.75 0 1 1 0 1.5h-.9a.75.75 0 0 1-.609-.312L9 8.408l-.741 1.03a.75.75 0 0 1-.609.312h-.9a.75.75 0 1 1 0-1.5h.516l.81-1.125L7.266 6H6.75a.75.75 0 1 1 0-1.5h.9a.75.75 0 0 1 .609.312L9 5.842l.741-1.03a.75.75 0 0 1 .609-.312h.9a.75.75 0 1 1 0 1.5h-.516l-.81 1.125zM4.356 4.5h.519a.75.75 0 1 1 0 1.5h-.84l-.867 4.045A2.473 2.473 0 0 1 .75 12a.75.75 0 1 1 0-1.5c.459 0 .855-.32.951-.77l.8-3.73h-.626a.75.75 0 1 1 0-1.5h.947l.385-1.795A2.473 2.473 0 0 1 5.625.75a.75.75 0 1 1 0 1.5.973.973 0 0 0-.951.77L4.356 4.5z"
    }))
  }, props));
});

var UploadDocumentSpinner = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 270 136",
      enableBackground: "new 0 0 270 136",
      width: "300px",
      height: "150px"
    }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      fill: "#E3F6FF",
      d: "M74.7 100.8c0-5.4-4.3-9.7-9.7-9.7H9.7c-5.4 0-9.7-4.3-9.7-9.7V77c0-5.4 4.3-9.7 9.7-9.7h54c5.4 0 9.7-4.3 9.7-9.7v-1.7c0-5.4-4.3-9.7-9.7-9.7H53c-5.4 0-9.7-4.3-9.7-9.7v-4.4c0-5.4 4.4-9.7 9.7-9.7h22.5c5.4 0 9.7-4.3 9.7-9.7v-3c0-5.4 4.3-9.7 9.7-9.7H217c5.4 0 9.7 4.3 9.7 9.7v4.4c0 5.4-4.3 9.7-9.7 9.7h-13.4c-5.4 0-9.7 4.3-9.7 7.4l0 0v4c0 5.4 4.3 9.7 9.7 9.7h56.6c5.4 0 9.7 4.3 9.7 9.7V59c0 5.4-4.3 9.7-9.7 9.7h-54c-5.4 0-9.7 4.3-9.7 9.7v1.7c0 5.4 4.3 9.7 9.7 9.7h21.2c5.4 0 9.7 4.3 9.7 9.7v4.4c0 5.4-4.3 9.7-9.7 9.7h-33c-5.4 0-9.7 4.3-9.7 9.7v3c0 5.4-4.3 9.7-9.7 9.7H53c-5.4 0-9.7-4.3-9.7-9.7v-4.4c0-5.4 4.3-9.7 9.7-9.7H65c5.4 0 9.7-4.3 9.7-9.7V100.8z"
    }), /*#__PURE__*/React.createElement("g", {
      transform: "translate(63 16)"
    }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      id: "prev-a",
      fill: "#A3B0B6",
      d: "M51.7 80.6c0.4-1.4 1.8-2.6 3.3-2.6h9.9c1.5 0 3 1.2 3.3 2.6l2.7 11c0.4 1.6 1.7 3.8 2.9 5l4.7 4.4c2.4 2.3 1.7 4.1-1.6 4.1H43c-3.3 0-4-1.8-1.6-4.1l4.6-4.3c1.2-1.1 2.5-3.3 2.9-4.9L51.7 80.6z"
    })), /*#__PURE__*/React.createElement("path", {
      fill: "none",
      stroke: "#444444",
      strokeWidth: "2",
      d: "M52.7 80.9c0.2-1 1.3-1.9 2.4-1.9h9.9c1 0 2.1 0.9 2.4 1.9l2.7 11c0.4 1.8 1.8 4.2 3.2 5.5l4.7 4.4c1.8 1.6 1.5 2.4-0.9 2.4H43c-2.4 0-2.7-0.7-0.9-2.4l4.6-4.3c1.3-1.3 2.7-3.6 3.2-5.4L52.7 80.9z"
    }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
      id: "prev-b",
      fill: "#CFD8DC",
      d: "M0 2.7C0 1.2 1.2 0 2.7 0h114.6c1.5 0 2.7 1.2 2.7 2.7v79.6c0 1.5-1.2 2.7-2.7 2.7H2.7C1.2 85 0 83.8 0 82.3V2.7z"
    })), /*#__PURE__*/React.createElement("path", {
      fill: "none",
      stroke: "#444444",
      strokeWidth: "2",
      d: "M1 2.7C1 1.8 1.8 1 2.7 1h114.6c0.9 0 1.7 0.8 1.7 1.7v79.6c0 0.9-0.8 1.7-1.7 1.7H2.7C1.8 84 1 83.2 1 82.3V2.7z"
    }), /*#__PURE__*/React.createElement("ellipse", {
      fill: "#FFFFFF",
      stroke: "#444444",
      strokeWidth: "2",
      cx: "60",
      cy: "77",
      rx: "3",
      ry: "3"
    }), /*#__PURE__*/React.createElement("g", {
      transform: "translate(5.985 6)"
    }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
      id: "prev-c",
      x: "0",
      fill: "#FFFFFF",
      width: "108",
      height: "65"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "1",
      y: "1",
      fill: "none",
      stroke: "#444444",
      strokeWidth: "2",
      width: "106",
      height: "63"
    }), /*#__PURE__*/React.createElement("g", {
      transform: "translate(32.015 4)"
    }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
      id: "prev-d",
      x: "0",
      fill: "#FFFFFF",
      width: "44",
      height: "57"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "1",
      y: "1",
      fill: "none",
      stroke: "#444444",
      strokeWidth: "2",
      width: "42",
      height: "55"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "6",
      y: "16",
      fill: "#DDDDDD",
      width: "32",
      height: "2",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el3",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.15s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el2.end"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el11",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "6",
      y: "8",
      fill: "#FF9000",
      width: "20",
      height: "2",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el1",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.5s",
      repeatCount: "1",
      fill: "freeze",
      begin: "1s;el16.end + 0.5s"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el9",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "30",
      y: "8",
      fill: "#DDDDDD",
      width: "8",
      height: "2",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el2",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.5s",
      fill: "freeze",
      repeatCount: "1",
      begin: "el1.end"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el10",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    })), /*#__PURE__*/React.createElement("polygon", {
      fill: "#DDDDDD",
      points: "6 24 38 24 38 26 6 26",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el4",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.25s",
      fill: "freeze",
      repeatCount: "1",
      begin: "el3.end"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el12",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    })), /*#__PURE__*/React.createElement("polygon", {
      fill: "#DDDDDD",
      points: "6 32 20 32 20 34 6 34",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el5",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.25s",
      fill: "freeze",
      repeatCount: "1",
      begin: "el4.end"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el13",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    })), /*#__PURE__*/React.createElement("polygon", {
      fill: "#DDDDDD",
      points: "6 40 20 40 20 42 6 42",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el6",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.25s",
      fill: "freeze",
      repeatCount: "1",
      begin: "el4.end"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el14",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    })), /*#__PURE__*/React.createElement("polygon", {
      fill: "#DDDDDD",
      points: "6 48 28 48 28 50 6 50",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el8",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.25s",
      fill: "freeze",
      repeatCount: "1",
      begin: "el7.end"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el16",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    })), /*#__PURE__*/React.createElement("path", {
      fill: "none",
      stroke: "#FF9000",
      strokeWidth: "2",
      d: "M25 33h12v8H25V33z",
      opacity: "0"
    }, /*#__PURE__*/React.createElement("animate", {
      id: "el7",
      attributeName: "opacity",
      from: "0",
      to: "1",
      dur: "0.5s",
      fill: "freeze",
      repeatCount: "1",
      begin: "el6.end"
    }), /*#__PURE__*/React.createElement("animate", {
      id: "el15",
      attributeName: "opacity",
      from: "1",
      to: "0",
      dur: "1s",
      repeatCount: "1",
      fill: "freeze",
      begin: "el8.end + 0.5s"
    }))))), /*#__PURE__*/React.createElement("g", {
      transform: "translate(158 76)"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#A4E1F6",
      d: "M24 48c13.3 0 24-10.7 24-24S37.3 0 24 0 0 10.7 0 24 10.7 48 24 48z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#444444",
      d: "M24 46c12.2 0 22-9.8 22-22S36.2 2 24 2 2 11.8 2 24 11.8 46 24 46zM24 48C10.7 48 0 37.3 0 24S10.7 0 24 0s24 10.7 24 24S37.3 48 24 48z"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#FFFFFF",
      d: "M24 41c9.4 0 17-7.6 17-17S33.4 7 24 7 7 14.6 7 24 14.6 41 24 41z"
    }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      from: "0 24 24",
      to: "360 24 24",
      dur: "3s",
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("rect", {
      width: "48",
      height: "48",
      fill: "transparent"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#287DAA",
      d: "M33.2 14.8L33.2 14.8c0.8 0.8 0.8 2 0 2.8l-9.9 9.9c-0.8 0.8-2 0.8-2.8 0l0 0c-0.8-0.8-0.8-2 0-2.8l9.9-9.9C31.1 14 32.4 14 33.2 14.8z"
    })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      from: "0 24 24",
      to: "360 24 24",
      dur: "1.5s",
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("rect", {
      width: "48",
      height: "48",
      opacity: "0"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#67BB6B",
      d: "M24 9L24 9c1.1 0 2 0.9 2 2v16c0 1.1-0.9 2-2 2l0 0c-1.1 0-2-0.9-2-2V11C22 9.9 22.9 9 24 9z"
    })), /*#__PURE__*/React.createElement("circle", {
      fill: "#FFE140",
      cx: "24",
      cy: "24",
      r: "1"
    }), /*#__PURE__*/React.createElement("path", {
      fill: "#444444",
      d: "M24 27c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S25.7 27 24 27zM24 25c0.6 0 1-0.4 1-1s-0.4-1-1-1 -1 0.4-1 1S23.4 25 24 25z"
    }))))
  }, props));
});

var index = {
  CheckMarkIcon: CheckMarkIcon,
  DocumentBroken: DocumentBroken,
  DocumentIcon: DocumentIcon,
  NextIcon: NextIcon,
  PagePreviewIcon: PagePreviewIcon,
  PreviousIcon: PreviousIcon,
  SpinnerIcon: SpinnerIcon,
  StackIcon: StackIcon,
  UploadDocumentSpinner: UploadDocumentSpinner,
  CalendarIcon: CalendarIcon,
  DownIcon: DownIcon,
  PictureIcon: PictureIcon,
  SignatureIcon: SignatureIcon,
  InitialsIcon: InitialsIcon,
  HashIcon: HashIcon,
  FormulaIcon: FormulaIcon
};

var Checkbox = function Checkbox(_ref) {
  var _cx;

  var ariaLabel = _ref.ariaLabel,
      css = _ref.css,
      checked = _ref.checked,
      disabled = _ref.disabled,
      label = _ref.label,
      onChange = _ref.onChange;

  var mergedCSS = _objectSpread2({}, Checkbox.defaultProps.css, {}, css);

  var theme = mergedCSS.theme;
  var componentClassName = cx(styles.checkbox, (_cx = {}, _defineProperty(_cx, styles["checkbox--theme--".concat(theme)], theme), _defineProperty(_cx, styles['is-checked'], checked), _defineProperty(_cx, styles['is-disabled'], disabled), _cx));

  var handleClick = function handleClick(e) {
    onChange(e);
  };

  var onKeyDown = function onKeyDown(e) {
    // Simulate click on press Space
    if (e.charCode === 32 || e.keyCode === 32) {
      e.preventDefault();
      onChange(e);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    role: "checkbox",
    className: componentClassName,
    tabIndex: disabled ? -1 : 0,
    "aria-checked": String(checked),
    "aria-disabled": String(disabled),
    "aria-label": ariaLabel,
    "data-qa-tag": "checkbox",
    "data-qa-states": cx({
      checked: checked,
      disabled: disabled
    }),
    onKeyDown: onKeyDown,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.checkbox__body,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.checkbox__indicator
  }, /*#__PURE__*/React.createElement(CheckMarkIcon, null)), label && /*#__PURE__*/React.createElement("div", {
    className: styles.checkbox__label
  }, /*#__PURE__*/React.createElement(Text, {
    value: label
  }))));
};

Checkbox.defaultProps = {
  ariaLabel: '',
  checked: false,
  disabled: false,
  css: {
    theme: 'primary'
  },
  label: null,
  onChange: function onChange() {}
};

var css_248z$3 = "._2CrqF{align-items:flex-start}._1EGEZ{align-items:center}.hfS2F{align-items:flex-end}._3VvAP{justify-content:flex-start}._2_6C7{justify-content:center}._28Jsi{justify-content:flex-end}.Dvqra{justify-content:space-between}._2G1nr{flex-grow:0}._1Ji62{flex-grow:1}._2PPBa{flex-shrink:0}._2GGyF{flex-shrink:1}._35-AQ{padding-top:.125em!important}._3RPRq{padding-top:.25em!important}._1pEbe{padding-top:.375em!important}._23W76{padding-top:.5em!important}._1Jgne{padding-top:.625em!important}._3jC8l{padding-top:.75em!important}._2nRV-{padding-top:.875em!important}._2lnbD{padding-right:.125em!important}._2rQlz{padding-right:.25em!important}.OUTnI{padding-right:.375em!important}._2ulSe{padding-right:.5em!important}._1rxy2{padding-right:.625em!important}.Utljf{padding-right:.75em!important}._2CtgS{padding-right:.875em!important}.sy1Dh{padding-bottom:.125em!important}._3T1we{padding-bottom:.25em!important}._2vM-g{padding-bottom:.375em!important}.uWtMV{padding-bottom:.5em!important}.mXIFD{padding-bottom:.625em!important}._29SIx{padding-bottom:.75em!important}._2uDY{padding-bottom:.875em!important}.EozXW{padding-left:.125em!important}.G1rfC{padding-left:.25em!important}._539Q6{padding-left:.375em!important}.VyH4H{padding-left:.5em!important}._3bL4m{padding-left:.625em!important}._1s5SS{padding-left:.75em!important}._5-zEv{padding-left:.875em!important}._2kg14{padding:.125em!important}._1wTNV{padding:.25em!important}._2JwXf{padding:.375em!important}.eatEE{padding:.5em!important}.NdOVG{padding:.625em!important}._dQqM{padding:.75em!important}._1N-3h{padding:.875em!important}._3sx6H{border-radius:999em!important}._SLZB{border-radius:50%!important}.eLlLL{border-radius:inherit!important}._3SUWU{pointer-events:none!important}._24GyE{position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}";
var globalStyles = {"align-items-flex-start":"_2CrqF","align-items-center":"_1EGEZ","align-items-flex-end":"hfS2F","justify-content-flex-start":"_3VvAP","justify-content-center":"_2_6C7","justify-content-flex-end":"_28Jsi","justify-content-space-between":"Dvqra","flex-grow-0":"_2G1nr","flex-grow-1":"_1Ji62","flex-shrink-0":"_2PPBa","flex-shrink-1":"_2GGyF","padding-top-2xs":"_35-AQ","padding-top-xs":"_3RPRq","padding-top-s":"_1pEbe","padding-top-m":"_23W76","padding-top-l":"_1Jgne","padding-top-xl":"_3jC8l","padding-top-2xl":"_2nRV-","padding-right-2xs":"_2lnbD","padding-right-xs":"_2rQlz","padding-right-s":"OUTnI","padding-right-m":"_2ulSe","padding-right-l":"_1rxy2","padding-right-xl":"Utljf","padding-right-2xl":"_2CtgS","padding-bottom-2xs":"sy1Dh","padding-bottom-xs":"_3T1we","padding-bottom-s":"_2vM-g","padding-bottom-m":"uWtMV","padding-bottom-l":"mXIFD","padding-bottom-xl":"_29SIx","padding-bottom-2xl":"_2uDY","padding-left-2xs":"EozXW","padding-left-xs":"G1rfC","padding-left-s":"_539Q6","padding-left-m":"VyH4H","padding-left-l":"_3bL4m","padding-left-xl":"_1s5SS","padding-left-2xl":"_5-zEv","padding-2xs":"_2kg14","padding-xs":"_1wTNV","padding-s":"_2JwXf","padding-m":"eatEE","padding-l":"NdOVG","padding-xl":"_dQqM","padding-2xl":"_1N-3h","is-rounded":"_3sx6H","is-circled":"_SLZB","inherit-border-radius":"eLlLL","is-inaccessible":"_3SUWU","is-visuallyhidden":"_24GyE"};
styleInject(css_248z$3);

var globalClasses = (function (cssProps) {
  var _ref;

  if (Object.prototype.toString.call(cssProps) !== '[object Object]') {
    /* eslint-disable-next-line no-console */
    console.error('`cssProps` is not Object');
  }

  var flexGrow = cssProps.flexGrow,
      flexShrink = cssProps.flexShrink,
      alignItems = cssProps.alignItems,
      justifyContent = cssProps.justifyContent,
      padding = cssProps.padding,
      paddingTop = cssProps.paddingTop,
      paddingRight = cssProps.paddingRight,
      paddingBottom = cssProps.paddingBottom,
      paddingLeft = cssProps.paddingLeft,
      margin = cssProps.margin,
      marginTop = cssProps.marginTop,
      marginRight = cssProps.marginRight,
      marginBottom = cssProps.marginBottom,
      marginLeft = cssProps.marginLeft,
      circled = cssProps.circled,
      rounded = cssProps.rounded,
      inaccessible = cssProps.inaccessible,
      inheritBorderRadius = cssProps.inheritBorderRadius;
  return _ref = {}, _defineProperty(_ref, globalStyles["flex-grow-".concat(flexGrow)], flexGrow), _defineProperty(_ref, globalStyles["flex-shrink-".concat(flexShrink)], flexShrink), _defineProperty(_ref, globalStyles["align-items-".concat(alignItems)], alignItems), _defineProperty(_ref, globalStyles["justify-content-".concat(justifyContent)], justifyContent), _defineProperty(_ref, globalStyles["padding-".concat(padding)], padding), _defineProperty(_ref, globalStyles["padding-top-".concat(paddingTop)], paddingTop), _defineProperty(_ref, globalStyles["padding-right-".concat(paddingRight)], paddingRight), _defineProperty(_ref, globalStyles["padding-bottom-".concat(paddingBottom)], paddingBottom), _defineProperty(_ref, globalStyles["padding-left-".concat(paddingLeft)], paddingLeft), _defineProperty(_ref, globalStyles["margin-".concat(margin)], margin), _defineProperty(_ref, globalStyles["margin-top-".concat(marginTop)], marginTop), _defineProperty(_ref, globalStyles["margin-right-".concat(marginRight)], marginRight), _defineProperty(_ref, globalStyles["margin-bottom-".concat(marginBottom)], marginBottom), _defineProperty(_ref, globalStyles["margin-left-".concat(marginLeft)], marginLeft), _defineProperty(_ref, globalStyles['is-circled'], circled), _defineProperty(_ref, globalStyles['is-rounded'], rounded), _defineProperty(_ref, globalStyles['is-inaccessible'], inaccessible), _defineProperty(_ref, globalStyles['inherit-border-radius'], inheritBorderRadius), _ref;
});

var css_248z$4 = "._4juv8{z-index:1;display:inline-flex;max-width:100%;max-height:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;line-height:0;padding:0;margin:0;vertical-align:middle;cursor:pointer;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent;-webkit-appearance:none}._4juv8,._2727C{position:relative;box-sizing:border-box}._2727C{z-index:3;display:flex;align-items:inherit;justify-content:inherit;width:100%;flex-grow:1;height:100%;min-height:inherit;outline:none;overflow:hidden}._4juv8:not(._24N3e):not(._2RD8A):focus{z-index:2;box-shadow:0 0 0 .125em #8acbff}._4juv8._24N3e{cursor:not-allowed}._25bp6{background-color:#444;border-radius:.25em;color:#fff;text-decoration:none}@media (hover:hover){._25bp6:hover{background-color:#5e5e5e}}._25bp6:active{background-color:#373737}._25bp6:focus{outline:none}._25bp6:focus:not(._24N3e){z-index:2;box-shadow:0 0 0 .125em #d4d4d4}._25bp6._24N3e{background-color:#c4c4c4;color:#f2f2f2}._25bp6._12NAW{color:#fff;background-color:#000}.Hq8Vk{text-decoration:none}.Hq8Vk:not(._12NAW){color:#666;background-color:#fff;border-bottom:.0625em solid #e4e4e4}@media (hover:hover){.Hq8Vk:not(._12NAW):not(._24N3e):hover{background-color:#f2f2f2}}.Hq8Vk:not(._12NAW):not(._24N3e):active{box-shadow:inset 0 0 .75em #e6e6e6;background-color:#fff}.Hq8Vk:not(._24N3e)._12NAW{color:#444;background-color:#fafafa;border-bottom:.0625em solid #fafafa}.Hq8Vk:not(._24N3e)._12NAW:before{height:.1875em;background-color:#ff9000;content:\"\";display:block;position:absolute;top:0;left:-1px;right:-1px}.Hq8Vk:not(._24N3e)._12NAW:focus,.Hq8Vk:not(._24N3e):focus{box-shadow:0 0 0 .125em #8acbff}.Hq8Vk:not(._24N3e):focus{outline:none;border-bottom-color:#fff;z-index:2}@media (hover:hover){.Hq8Vk:not(._24N3e):focus:hover{border-bottom-color:#f2f2f2}}.Hq8Vk._24N3e{color:#999}.qrsD4{height:1.375em}.VyXwg{height:2em}._1Tgra{height:2.625em}._23KQU{width:100%}._3KjGU{width:2em}._1oEWa{position:relative;z-index:1;display:inline-flex;max-width:100%;max-height:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0;line-height:0;padding:0;margin:0;align-items:center;justify-content:center;vertical-align:middle}._1kLj2,._1oEWa{box-sizing:border-box}._1kLj2{display:flex;align-items:inherit;justify-content:inherit;width:100%;flex-grow:1;height:100%;outline:none}._1kLj2:before{display:block;height:1em;content:\"\";background-color:#ccc;width:100%}._1oEWa._12NAW ._1kLj2:before{box-shadow:0 0 0 1px #ff9000}";
var styles$3 = {"control":"_4juv8","control__body":"_2727C","is-disabled":"_24N3e","is-inaccessible":"_2RD8A","control--theme--dark-gray":"_25bp6","is-active":"_12NAW","control--theme--mercury-highlighted":"Hq8Vk","height--s":"qrsD4","height--m":"VyXwg","height--l":"_1Tgra","width--parent":"_23KQU","width--m":"_3KjGU","control-placeholder":"_1oEWa","control-placeholder__body":"_1kLj2"};
styleInject(css_248z$4);

var Control = function Control(_ref) {
  var _cx;

  var children = _ref.children,
      css = _ref.css,
      otherAttributes = _ref.otherAttributes,
      tagName = _ref.tagName,
      active = _ref.active,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  var CustomTag = tagName;

  var mergedCSS = _objectSpread2({}, Control.defaultProps.css, {}, css);

  var alignItems = mergedCSS.alignItems,
      circled = mergedCSS.circled,
      height = mergedCSS.height,
      inheritBorderRadius = mergedCSS.inheritBorderRadius,
      justifyContent = mergedCSS.justifyContent,
      minHeight = mergedCSS.minHeight,
      minWidth = mergedCSS.minWidth,
      rounded = mergedCSS.rounded,
      theme = mergedCSS.theme,
      width = mergedCSS.width,
      padding = mergedCSS.padding,
      paddingTop = mergedCSS.paddingTop,
      paddingRight = mergedCSS.paddingRight,
      paddingBottom = mergedCSS.paddingBottom,
      paddingLeft = mergedCSS.paddingLeft;
  var componentClassName = cx(styles$3.control, (_cx = {}, _defineProperty(_cx, styles$3['is-active'], active), _defineProperty(_cx, styles$3['is-disabled'], disabled), _defineProperty(_cx, styles$3["control--theme--".concat(theme)], theme), _defineProperty(_cx, styles$3["height--".concat(height)], height), _defineProperty(_cx, styles$3["min-height--".concat(minHeight)], minHeight), _defineProperty(_cx, styles$3["min-width--".concat(minWidth)], minWidth), _defineProperty(_cx, styles$3["width--".concat(width)], width), _cx), globalClasses({
    alignItems: alignItems,
    circled: circled,
    inheritBorderRadius: inheritBorderRadius,
    justifyContent: justifyContent,
    rounded: rounded
  }));
  var bodyClassName = cx(styles$3.control__body, globalClasses({
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft
  }));

  var handleKeyDown = function handleKeyDown(e) {
    // Simulate click on press Space
    if (e.charCode === 32 || e.keyCode === 32) {
      e.preventDefault();
      onClick(e);
    }
  };

  return /*#__PURE__*/React.createElement(CustomTag, _extends({
    className: componentClassName,
    tabIndex: disabled ? -1 : 0,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    "data-qa-states": cx({
      active: active,
      disabled: disabled
    }),
    "data-qa-tag": "control"
  }, otherAttributes), /*#__PURE__*/React.createElement("div", {
    className: bodyClassName,
    tabIndex: -1
  }, children));
};

Control.defaultProps = {
  css: {
    alignItems: null,
    circled: false,
    height: null,
    inheritBorderRadius: false,
    justifyContent: null,
    minHeight: null,
    minWidth: null,
    padding: null,
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
    rounded: false,
    theme: null,
    width: null
  },
  tagName: null,
  active: false,
  disabled: false,
  onClick: function onClick() {}
};

var Button = function Button(_ref) {
  var children = _ref.children,
      active = _ref.active,
      disabled = _ref.disabled,
      css = _ref.css,
      title = _ref.title,
      ariaLabel = _ref.ariaLabel,
      onClick = _ref.onClick;

  var mergedCSS = _objectSpread2({}, Button.defaultProps.css, {}, css);

  return /*#__PURE__*/React.createElement(Control, {
    css: mergedCSS,
    active: active,
    disabled: disabled,
    otherAttributes: {
      title: title,
      role: 'button',
      'aria-label': ariaLabel
    },
    tagName: "div",
    onClick: onClick
  }, children);
};

Button.defaultProps = {
  css: {
    alignItems: 'center',
    circled: false,
    height: 'm',
    inheritBorderRadius: false,
    justifyContent: 'center',
    minHeight: null,
    minWidth: null,
    padding: null,
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
    rounded: false,
    theme: 'primary',
    width: null
  },
  title: null,
  ariaLabel: null,
  active: false,
  disabled: false,
  onClick: function onClick() {}
};

var Tab = function Tab(_ref) {
  var children = _ref.children,
      active = _ref.active,
      css = _ref.css,
      ariaControls = _ref.ariaControls,
      ariaSelected = _ref.ariaSelected,
      id = _ref.id,
      index = _ref.index,
      title = _ref.title,
      onClick = _ref.onClick;

  var mergedCSS = _objectSpread2({}, Tab.defaultProps.css, {}, css);

  return /*#__PURE__*/React.createElement(Control, {
    css: mergedCSS,
    active: active,
    tagName: "div",
    otherAttributes: {
      id: id,
      title: title,
      role: 'tab',
      'data-index': index,
      'aria-controls': ariaControls,
      'aria-selected': ariaSelected
    },
    onClick: onClick
  }, children);
};

Tab.defaultProps = {
  active: false,
  css: {
    alignItems: 'center',
    circled: false,
    disabled: false,
    inheritBorderRadius: false,
    justifyContent: 'center',
    paddingLeft: '2xl',
    paddingRight: '2xl',
    rounded: false,
    theme: 'mercury-highlighted',
    minHeight: null,
    minWidth: null,
    width: 'parent',
    height: 'l'
  },
  title: null,
  onClick: function onClick() {}
};

var Link = function Link(_ref) {
  var children = _ref.children,
      css = _ref.css,
      href = _ref.href,
      target = _ref.target,
      title = _ref.title,
      onClick = _ref.onClick;

  var mergedCSS = _objectSpread2({}, Link.defaultProps.css, {}, css);

  return /*#__PURE__*/React.createElement(Control, {
    css: mergedCSS,
    otherAttributes: {
      href: href,
      target: target,
      title: title
    },
    onClick: onClick
  }, children);
};

Link.defaultProps = {
  css: {
    alignItems: 'center',
    circled: false,
    disabled: false,
    height: null,
    inheritBorderRadius: false,
    justifyContent: 'center',
    minHeight: null,
    minWidth: null,
    padding: null,
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
    rounded: false,
    theme: null,
    width: null
  },
  target: null,
  title: null,
  onClick: function onClick() {}
};

var ControlPlaceholder = function ControlPlaceholder(_ref) {
  var _cx;

  var css = _ref.css,
      active = _ref.active;

  var mergedCSS = _objectSpread2({}, ControlPlaceholder.defaultProps.css, {}, css);

  var alignItems = mergedCSS.alignItems,
      circled = mergedCSS.circled,
      height = mergedCSS.height,
      inheritBorderRadius = mergedCSS.inheritBorderRadius,
      justifyContent = mergedCSS.justifyContent,
      minHeight = mergedCSS.minHeight,
      minWidth = mergedCSS.minWidth,
      padding = mergedCSS.padding,
      paddingBottom = mergedCSS.paddingBottom,
      paddingLeft = mergedCSS.paddingLeft,
      paddingRight = mergedCSS.paddingRight,
      paddingTop = mergedCSS.paddingTop,
      rounded = mergedCSS.rounded,
      width = mergedCSS.width;
  var componentClassName = cx(styles$3['control-placeholder'], (_cx = {}, _defineProperty(_cx, styles$3['is-active'], active), _defineProperty(_cx, styles$3["height--".concat(height)], height), _defineProperty(_cx, styles$3["min-height--".concat(minHeight)], minHeight), _defineProperty(_cx, styles$3["min-width--".concat(minWidth)], minWidth), _defineProperty(_cx, styles$3["width--".concat(width)], width), _cx), globalClasses({
    alignItems: alignItems,
    circled: circled,
    inheritBorderRadius: inheritBorderRadius,
    justifyContent: justifyContent,
    rounded: rounded
  }));
  var bodyClassName = cx(styles$3['control-placeholder__body'], globalClasses({
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: bodyClassName
  }));
};

ControlPlaceholder.defaultProps = {
  css: {
    alignItems: 'center',
    circled: false,
    inheritBorderRadius: false,
    justifyContent: 'center',
    padding: null,
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
    rounded: false,
    height: null,
    width: null,
    minHeight: 'm',
    minWidth: null
  },
  active: false
};

var css_248z$5 = "._3LV8-{max-width:100%}._3LV8->._3OOhM>._3PrtT,._3LV8->._3OOhM>._3PrtT>._2vR_E{display:flex}.y025h ._3PrtT:first-child ._2vR_E{padding-top:0!important}.y025h ._3PrtT:last-child ._2vR_E{padding-bottom:0!important}";
var styles$4 = {"grid":"_3LV8-","grid__body":"_3OOhM","grid__row":"_3PrtT","grid__cell":"_2vR_E","type--compact":"y025h"};
styleInject(css_248z$5);

var GridRow = function GridRow(_ref) {
  var children = _ref.children,
      css = _ref.css;

  var mergedCSS = _objectSpread2({}, GridRow.defaultProps.css, {}, css);

  var padding = mergedCSS.padding,
      paddingTop = mergedCSS.paddingTop,
      paddingRight = mergedCSS.paddingRight,
      paddingBottom = mergedCSS.paddingBottom,
      paddingLeft = mergedCSS.paddingLeft,
      alignItems = mergedCSS.alignItems,
      justifyContent = mergedCSS.justifyContent;
  var elementClassName = cx(styles$4.grid__row, globalClasses({
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    alignItems: alignItems,
    justifyContent: justifyContent
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: elementClassName
  }, children);
};

GridRow.defaultProps = {
  css: {
    padding: null,
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
    alignItems: null,
    justifyContent: null
  }
};

var GridCell = function GridCell(_ref) {
  var children = _ref.children,
      css = _ref.css;

  var mergedCSS = _objectSpread2({}, GridCell.defaultProps.css, {}, css);

  var padding = mergedCSS.padding,
      paddingTop = mergedCSS.paddingTop,
      paddingRight = mergedCSS.paddingRight,
      paddingBottom = mergedCSS.paddingBottom,
      paddingLeft = mergedCSS.paddingLeft,
      flexGrow = mergedCSS.flexGrow,
      flexShrink = mergedCSS.flexShrink;
  var elementClassName = cx(styles$4.grid__cell, globalClasses({
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    flexGrow: flexGrow,
    flexShrink: flexShrink
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: elementClassName
  }, children);
};

GridCell.defaultProps = {
  css: {
    padding: null,
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
    flexGrow: null,
    flexShrink: null
  }
};

var Grid = function Grid(_ref) {
  var children = _ref.children,
      css = _ref.css;

  var mergedCSS = _objectSpread2({}, Grid.defaultProps.css, {}, css);

  var type = mergedCSS.type;
  var componentClassName = cx(styles$4.grid, _defineProperty({}, styles$4["type--".concat(type)], type));
  return /*#__PURE__*/React.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.grid__body
  }, children));
};

Grid.defaultProps = {
  css: {
    type: null
  }
};
Grid.Row = GridRow;
Grid.Cell = GridCell;

var css_248z$6 = "._3pUAJ{position:relative;z-index:1;display:inline-flex;flex-grow:1}._1FL0S,._3pUAJ{vertical-align:middle}._2PdOu{width:100%}._3DrLt{height:100%}._1Dg9o{max-width:100%}.lDJFH{max-height:100%}._2IAOc{position:relative;z-index:1;width:100%;height:100%}._2IAOc ._1FL0S{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;max-width:100%;max-height:100%}";
var styles$5 = {"media":"_3pUAJ","media__item":"_1FL0S","width--parent":"_2PdOu","height--parent":"_3DrLt","max-width--parent":"_1Dg9o","max-height--parent":"lDJFH","behavior--contain-proportionally":"_2IAOc"};
styleInject(css_248z$6);

var Image = function Image(_ref) {
  var _cx;

  var alt = _ref.alt,
      css = _ref.css,
      src = _ref.src,
      title = _ref.title;

  var mergedCSS = _objectSpread2({}, Image.defaultProps.css, {}, css);

  var behavior = mergedCSS.behavior,
      maxWidth = mergedCSS.maxWidth,
      maxHeight = mergedCSS.maxHeight,
      width = mergedCSS.width,
      height = mergedCSS.height,
      circled = mergedCSS.circled,
      inheritBorderRadius = mergedCSS.inheritBorderRadius,
      rounded = mergedCSS.rounded;
  var componentClassName = cx(styles$5.media, (_cx = {}, _defineProperty(_cx, styles$5["width--".concat(width)], width), _defineProperty(_cx, styles$5["height--".concat(height)], height), _defineProperty(_cx, styles$5["max-width--".concat(maxWidth)], maxWidth), _defineProperty(_cx, styles$5["max-height--".concat(maxHeight)], maxHeight), _defineProperty(_cx, styles$5["behavior--".concat(behavior)], behavior), _cx), globalClasses({
    circled: circled,
    inheritBorderRadius: inheritBorderRadius,
    rounded: rounded
  }));
  return /*#__PURE__*/React.createElement("img", {
    className: componentClassName,
    src: src,
    title: title,
    alt: alt
  });
};

Image.defaultProps = {
  css: {
    behavior: null,
    circled: false,
    height: null,
    inheritBorderRadius: false,
    maxHeight: null,
    maxWidth: null,
    rounded: false,
    width: null
  },
  title: null
};

var Canvas = function Canvas(_ref) {
  var _cx;

  var css = _ref.css,
      attrHeight = _ref.attrHeight,
      attrWidth = _ref.attrWidth;

  var mergedCSS = _objectSpread2({}, Canvas.defaultProps.css, {}, css);

  var behavior = mergedCSS.behavior,
      circled = mergedCSS.circled,
      height = mergedCSS.height,
      inheritBorderRadius = mergedCSS.inheritBorderRadius,
      maxHeight = mergedCSS.maxHeight,
      maxWidth = mergedCSS.maxWidth,
      rounded = mergedCSS.rounded,
      width = mergedCSS.width;
  var componentClassName = cx(styles$5.media, (_cx = {}, _defineProperty(_cx, styles$5["width--".concat(width)], width), _defineProperty(_cx, styles$5["height--".concat(height)], height), _defineProperty(_cx, styles$5["max-width--".concat(maxWidth)], maxWidth), _defineProperty(_cx, styles$5["max-height--".concat(maxHeight)], maxHeight), _defineProperty(_cx, styles$5["behavior--".concat(behavior)], behavior), _cx), globalClasses({
    circled: circled,
    inheritBorderRadius: inheritBorderRadius,
    rounded: rounded
  }));
  return /*#__PURE__*/React.createElement("canvas", {
    className: componentClassName,
    width: attrWidth,
    height: attrHeight
  });
};

Canvas.defaultProps = {
  css: {
    behavior: null,
    circled: false,
    height: null,
    inheritBorderRadius: false,
    maxHeight: null,
    maxWidth: null,
    rounded: false,
    width: null
  }
};

var css_248z$7 = ".AE2i_{display:block;padding:.625em}.fQgoz{display:grid;padding-left:0;margin-top:0;margin-bottom:0;grid-template-columns:repeat(auto-fill,minmax(12.875em,1fr));grid-auto-rows:12.875em;list-style-type:none;overflow:hidden}@supports not (display:grid){.fQgoz{display:flex;flex-direction:row;flex-wrap:wrap}}@media (-ms-high-contrast:none){.fQgoz{display:flex;flex-direction:row;flex-wrap:wrap}}._2h5nY{display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:.75em;flex-shrink:0;box-sizing:border-box}@supports not (display:grid){._2h5nY{flex-grow:1;min-width:12.875em}}@media (-ms-high-contrast:none){._2h5nY{flex-grow:1;min-width:12.875em}}";
var styles$6 = {"page-list":"AE2i_","page-list__main":"fQgoz","page-list__item":"_2h5nY"};
styleInject(css_248z$7);

var PageListItem = function PageListItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    role: "listitem",
    className: styles$6['page-list__item']
  }, children);
};

PageListItem.defaultProps = {
  children: null
};

var PageListLayout = function PageListLayout(_ref) {
  var children = _ref.children,
      listRef = _ref.listRef;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6['page-list'],
    ref: listRef
  }, /*#__PURE__*/React.createElement("div", {
    role: "list",
    className: styles$6['page-list__main']
  }, children));
};

PageListLayout.defaultProps = {
  children: null,
  listRef: function listRef() {}
};

var css_248z$8 = "._1TFRF,._2uYtM,.pC_nc{display:flex;flex-grow:1;flex-direction:column}.pC_nc{position:relative;z-index:1}._20vKW{flex-shrink:0;padding-top:inherit}._29yEs ._2uYtM{justify-content:center}._2Ww1G._29yEs{color:#888;fill:currentColor}._2Ww1G._29yEs .pC_nc{border:.0625em dashed #ccc}";
var styles$7 = {"document-preview":"_1TFRF","document-preview__body":"_2uYtM","document-preview__main":"pC_nc","document-preview__action-bar":"_20vKW","document-preview--empty":"_29yEs","document-preview--theme--primary":"_2Ww1G"};
styleInject(css_248z$8);

var PreviewLayout = function PreviewLayout(_ref) {
  var _cx;

  var children = _ref.children,
      empty = _ref.empty,
      css = _ref.css,
      controlBar = _ref.controlBar;

  var mergedCSS = _objectSpread2({}, PreviewLayout.defaultProps.css, {}, css);

  var alignItems = mergedCSS.alignItems,
      justifyContent = mergedCSS.justifyContent,
      padding = mergedCSS.padding,
      paddingBottom = mergedCSS.paddingBottom,
      paddingLeft = mergedCSS.paddingLeft,
      paddingRight = mergedCSS.paddingRight,
      paddingTop = mergedCSS.paddingTop,
      theme = mergedCSS.theme;
  var componentClassName = cx(styles$7['document-preview'], (_cx = {}, _defineProperty(_cx, styles$7['document-preview--empty'], empty), _defineProperty(_cx, styles$7["document-preview--theme--".concat(theme)], theme), _cx));
  var bodyClassName = cx(styles$7['document-preview__body'], globalClasses({
    padding: padding,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: paddingTop
  }));
  var mainClassName = cx(styles$7['document-preview__main'], globalClasses({
    alignItems: alignItems,
    justifyContent: justifyContent
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: componentClassName,
    "data-qa-tag": "document-preview"
  }, /*#__PURE__*/React.createElement("div", {
    className: bodyClassName
  }, /*#__PURE__*/React.createElement("div", {
    className: mainClassName
  }, children), controlBar && /*#__PURE__*/React.createElement("div", {
    className: styles$7['document-preview__action-bar']
  }, controlBar)));
};

PreviewLayout.defaultProps = {
  empty: false,
  css: {
    padding: null,
    paddingTop: null,
    paddingRight: null,
    paddingBottom: null,
    paddingLeft: null,
    theme: 'primary'
  },
  controlBar: null
};

var css_248z$9 = "._3evJX{display:inline-block;vertical-align:middle}";
var styles$8 = {"progress":"_3evJX"};
styleInject(css_248z$9);

var InfiniteProgress = function InfiniteProgress(_ref) {
  var css = _ref.css;

  var mergedCSS = _objectSpread2({}, InfiniteProgress.defaultProps.css, {}, css);

  return /*#__PURE__*/React.createElement("div", {
    className: styles$8.progress
  }, /*#__PURE__*/React.createElement(SpinnerIcon, {
    css: mergedCSS
  }));
};

InfiniteProgress.defaultProps = {
  css: {
    width: 'l',
    height: 'l'
  }
};

var constants = {
  LIST_PAGE_LABEL: 'Page',
  PREVIOUS_PAGE_CONTROL_TEXT: 'Show previous page',
  EDIT_PAGE_CONTROL_TEXT: 'Edit Page',
  NEXT_PAGE_CONTROL_TEXT: 'Show next page',
  PREVIEW_CONTROL_TEXT: 'Preview',
  SELECT_PAGES_CONTROL_TEXT: 'Select Pages',
  LOADING_TEXT: 'Loading',
  EXCLUDED_PAGE_THUMBNAIL_TEXT: 'Excluded',
  NO_ONE_SELECTED_PAGE_TEXT: 'Please, select at least one page to see the preview',
  NOT_AVAILABLE_PAGE_PREVIEW_TEXT: 'Preview is not available for this document',
  GETTING_DOCUMENT_READY_TEXT: 'Getting Your Document Ready!'
};

var GETTING_DOCUMENT_READY_TEXT = constants.GETTING_DOCUMENT_READY_TEXT;

var UploadingDocumentProgress = function UploadingDocumentProgress(_ref) {
  var css = _ref.css;

  var mergedCSS = _objectSpread2({}, UploadingDocumentProgress.defaultProps.css, {}, css);

  return /*#__PURE__*/React.createElement("div", {
    className: styles$8.progress
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, {
    css: {
      paddingBottom: 'l'
    }
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(UploadDocumentSpinner, {
    css: mergedCSS
  }))), /*#__PURE__*/React.createElement(Grid.Row, {
    css: {
      paddingTop: 'l',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    tagName: "div",
    css: {
      textAlign: 'center',
      fontSize: 'xl',
      color: 'tundora'
    },
    value: GETTING_DOCUMENT_READY_TEXT
  })))));
};

UploadingDocumentProgress.defaultProps = {
  css: {}
};

var css_248z$a = "._1ecBx{position:absolute;top:0;left:0;width:100%;height:100%}._1ecBx,.lHij1{display:flex;flex-grow:1;flex-direction:column}.Vxe0U{background:#fafafa}";
var styles$9 = {"progress-bar":"_1ecBx","progress-bar__body":"lHij1","progress-bar--theme--alabaster":"Vxe0U"};
styleInject(css_248z$a);

var ProgressBar = function ProgressBar(_ref) {
  var children = _ref.children,
      css = _ref.css;

  var mergedCSS = _objectSpread2({}, ProgressBar.defaultProps.css, {}, css);

  var alignItems = mergedCSS.alignItems,
      justifyContent = mergedCSS.justifyContent,
      theme = mergedCSS.theme;
  var bodyClassNames = cx(styles$9['progress-bar__body'], _defineProperty({}, styles$9["progress-bar--theme--".concat(theme)], theme), globalClasses({
    alignItems: alignItems,
    justifyContent: justifyContent
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9['progress-bar'],
    "data-qa-tag": "progress-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: bodyClassNames
  }, children));
};

ProgressBar.defaultProps = {
  css: {
    theme: null,
    alignItems: 'center',
    justifyContent: 'center'
  }
};

var css_248z$b = "._66VNp{overflow:auto;flex-basis:0}@media (pointer:coarse){._66VNp{-webkit-overflow-scrolling:touch}}._66VNp,.OtVog{display:flex;flex-direction:column;flex-grow:1}.OtVog{flex-shrink:0}";
var styles$a = {"scrollbar":"_66VNp","scrollbar__content":"OtVog"};
styleInject(css_248z$b);

var Scrollbar = /*#__PURE__*/function (_Component) {
  _inherits(Scrollbar, _Component);

  var _super = _createSuper(Scrollbar);

  function Scrollbar(props) {
    var _this;

    _classCallCheck(this, Scrollbar);

    _this = _super.call(this, props);
    _this.scrollBarRef = React.createRef();
    _this.setScrollPosition = _this.setScrollPosition.bind(_assertThisInitialized(_this));
    _this.calcPointerPosition = debounce(_this.calcPointerPosition.bind(_assertThisInitialized(_this)), 100);
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.state = {
      valueNow: 0
    };
    return _this;
  }

  _createClass(Scrollbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScrollPosition();
      this.calcPointerPosition(this.scrollBarRef.current);
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition() {
      var _this$props = this.props,
          scrollLeft = _this$props.scrollLeft,
          scrollTop = _this$props.scrollTop;

      if (scrollTop > 0) {
        this.scrollBarRef.current.scrollTop = scrollTop;
      }

      if (scrollLeft > 0) {
        this.scrollBarRef.current.scrollLeft = scrollLeft;
      }
    }
  }, {
    key: "calcPointerPosition",
    value: function calcPointerPosition(el) {
      var valueNow = el.scrollTop;
      var scrollSize = el.scrollHeight - el.offsetHeight;

      if (scrollSize > 0) {
        this.setState(function () {
          return {
            valueNow: Math.round(valueNow * 100 / scrollSize)
          };
        });
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(e) {
      var onScroll = this.props.onScroll;
      onScroll(e);
      this.calcPointerPosition(e.currentTarget);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          ariaControls = _this$props2.ariaControls,
          scrollOrientation = _this$props2.scrollOrientation;
      var valueNow = this.state.valueNow;
      return /*#__PURE__*/React.createElement("div", {
        "aria-controls": ariaControls,
        "aria-orientation": scrollOrientation,
        "aria-valuemax": "100",
        "aria-valuemin": "0",
        "aria-valuenow": valueNow,
        className: styles$a.scrollbar,
        ref: this.scrollBarRef,
        role: "scrollbar",
        "data-qa-tag": "scrollbar",
        onScroll: this.handleScroll
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$a.scrollbar__content
      }, children));
    }
  }]);

  return Scrollbar;
}(Component);

_defineProperty(Scrollbar, "defaultProps", {
  scrollLeft: 0,
  scrollOrientation: 'vertical',
  scrollTop: 0,
  onScroll: function onScroll() {}
});

var localCache = {};
var defaultScrollPosition = {
  scrollLeft: 0,
  scrollTop: 0
};

var MemorizedScrollbar = function MemorizedScrollbar(_ref) {
  var children = _ref.children,
      ariaControls = _ref.ariaControls,
      cacheId = _ref.cacheId;
  var cachePosition = debounce(function (scrollTop, scrollLeft) {
    localCache[cacheId] = {
      scrollTop: scrollTop,
      scrollLeft: scrollLeft
    };
  }, 200);

  var handleScroll = function handleScroll(e) {
    var _e$currentTarget = e.currentTarget,
        scrollTop = _e$currentTarget.scrollTop,
        scrollLeft = _e$currentTarget.scrollLeft;
    cachePosition(scrollTop, scrollLeft);
  };

  var _ref2 = localCache[cacheId] || defaultScrollPosition,
      scrollLeft = _ref2.scrollLeft,
      scrollTop = _ref2.scrollTop;

  return /*#__PURE__*/React.createElement(Scrollbar, {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop,
    onScroll: handleScroll,
    ariaControls: ariaControls
  }, children);
};

var id = 0;
var getUniqueId = (function () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  id += 1;
  return "".concat(prefix, "-").concat(id);
});

var css_248z$c = "._1Tza0,._3d579,._3g1jB,._39c8z{display:flex;flex-direction:column;flex-grow:1;width:100%}._2vqqY{display:table-cell;box-sizing:border-box}.yIzHN{width:100%;display:table;table-layout:fixed;z-index:2;padding-left:0;margin-top:0;margin-bottom:0;flex-shrink:0}._39c8z,.yIzHN{position:relative}._39c8z{z-index:1}._3d579{outline:none;overflow:hidden}._1cYV5 ._3d579{position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;visibility:hidden}._1cYV5 ._3d579._3BQR0{position:relative;z-index:2;visibility:visible}._3bEvJ{background-color:#fafafa}._3bEvJ ._2vqqY:not(:last-child){border-right:1px solid #e4e4e4}";
var styles$b = {"tabs":"_3g1jB","tabs__body":"_1Tza0","tabs__content":"_39c8z","tabs__panel":"_3d579","tabs__item":"_2vqqY","tabs__list":"yIzHN","tabs--type--multi-pane":"_1cYV5","is-active":"_3BQR0","tabs--theme--primary":"_3bEvJ"};
styleInject(css_248z$c);

var TabContent = function TabContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$b.tabs__content
  }, children);
};

var TabItem = function TabItem(_ref) {
  var children = _ref.children,
      css = _ref.css;

  var mergedCSS = _objectSpread2({}, TabItem.defaultProps.css, {}, css);

  var flexGrow = mergedCSS.flexGrow,
      flexShrink = mergedCSS.flexShrink;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles$b.tabs__item, globalClasses({
      flexGrow: flexGrow,
      flexShrink: flexShrink
    }))
  }, children);
};

TabItem.defaultProps = {
  css: {
    flexGrow: 1,
    flexShrink: 0
  }
};

var TabList = function TabList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    role: "tablist",
    className: styles$b.tabs__list
  }, children);
};

var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      active = _ref.active,
      ariaLabelledBy = _ref.ariaLabelledBy,
      cacheId = _ref.cacheId,
      id = _ref.id,
      scrollable = _ref.scrollable;

  var renderPanelContent = function renderPanelContent() {
    if (scrollable) {
      if (cacheId) {
        return /*#__PURE__*/React.createElement(MemorizedScrollbar, {
          cacheId: cacheId,
          ariaControls: ariaLabelledBy
        }, children);
      }

      return /*#__PURE__*/React.createElement(Scrollbar, {
        ariaControls: ariaLabelledBy
      }, children);
    }

    return children;
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    role: "tabpanel",
    "aria-labelledby": ariaLabelledBy,
    className: cx(styles$b.tabs__panel, _defineProperty({}, styles$b['is-active'], active))
  }, renderPanelContent());
};

TabPanel.defaultProps = {
  active: false,
  cacheId: null,
  scrollable: false
};

var TabsLayout = function TabsLayout(_ref) {
  var children = _ref.children,
      css = _ref.css;

  var mergedCSS = _objectSpread2({}, TabsLayout.defaultProps.css, {}, css);

  var theme = mergedCSS.theme;
  var componentClassName = cx(styles$b.tabs, styles$b['tabs--type--multi-pane'], _defineProperty({}, styles$b["tabs--theme--".concat(theme)], theme));
  return /*#__PURE__*/React.createElement("div", {
    className: componentClassName,
    "data-qa-tag": "tabs"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$b.tabs__body
  }, children));
};

TabsLayout.defaultProps = {
  css: {
    theme: 'primary'
  }
};

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleTabChange", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          selectedTabIndex = _this$props.selectedTabIndex,
          onChangeTab = _this$props.onChangeTab;
      var currentTabIndex = Number(e.currentTarget.getAttribute('data-index'));

      if (selectedTabIndex === currentTabIndex) {
        return;
      }

      onChangeTab(currentTabIndex, e);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTabControls", function () {
      var _this$props2 = _this.props,
          panels = _this$props2.panels,
          selectedTabIndex = _this$props2.selectedTabIndex,
          tabControl = _this$props2.tabControl;
      return panels.map(function (panel, index) {
        var title = panel.title,
            icon = panel.icon;
        var _this$tabProps$index = _this.tabProps[index],
            tabIndex = _this$tabProps$index.tabIndex,
            tabId = _this$tabProps$index.tabId,
            panelId = _this$tabProps$index.panelId;
        return tabControl ? /*#__PURE__*/React.createElement(TabItem, {
          key: tabId
        }, tabControl({
          icon: icon,
          title: title,
          id: tabId,
          ariaControls: panelId,
          active: Boolean(tabIndex === selectedTabIndex),
          ariaSelected: String(tabIndex === selectedTabIndex),
          onClick: _this.handleTabChange
        })) : /*#__PURE__*/React.createElement(TabItem, {
          key: tabId
        }, /*#__PURE__*/React.createElement(Tab, {
          id: tabId,
          index: index,
          ariaControls: panelId,
          active: Boolean(tabIndex === selectedTabIndex),
          ariaSelected: String(tabIndex === selectedTabIndex),
          onClick: _this.handleTabChange
        }, /*#__PURE__*/React.createElement(Grid, {
          css: {
            behavior: 'overflow-wrap'
          }
        }, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, {
          css: {
            paddingLeft: 'xs',
            paddingRight: 'xs',
            flexShrink: '0'
          }
        }, icon), /*#__PURE__*/React.createElement(Grid.Cell, {
          css: {
            paddingLeft: 'xs',
            paddingRight: 'xs'
          }
        }, /*#__PURE__*/React.createElement(Text, {
          css: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          },
          value: title
        }))))));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPanels", function () {
      var _this$props3 = _this.props,
          panels = _this$props3.panels,
          selectedTabIndex = _this$props3.selectedTabIndex;
      return panels.map(function (panel, index) {
        var _this$tabProps$index2 = _this.tabProps[index],
            tabId = _this$tabProps$index2.tabId,
            panelId = _this$tabProps$index2.panelId;
        return /*#__PURE__*/React.createElement(TabPanel, {
          id: panelId,
          key: panelId,
          active: Boolean(selectedTabIndex === index),
          ariaLabelledBy: tabId,
          cacheId: panel.cacheId,
          scrollable: panel.scrollable
        }, panel.render());
      });
    });

    _this.tabProps = props.panels.map(function (item, index) {
      return {
        tabIndex: index,
        tabId: getUniqueId('tab'),
        panelId: getUniqueId('tabpanel')
      };
    });
    return _this;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var css = this.props.css;
      var theme = css.theme;
      return /*#__PURE__*/React.createElement(TabsLayout, {
        theme: theme
      }, /*#__PURE__*/React.createElement(TabList, null, this.renderTabControls()), /*#__PURE__*/React.createElement(TabContent, null, this.renderPanels()));
    }
  }]);

  return Tabs;
}(Component);

Tabs.defaultProps = {
  css: {
    theme: 'primary'
  },
  selectedTabIndex: 0,
  tabControl: null,
  onChangeTab: function onChangeTab() {}
};

var css_248z$d = "._31WnL{display:inline-flex}.u0kNr{position:relative;z-index:1}._1cTNw,.u0kNr{min-width:50px;min-height:50px}._1cTNw{display:flex;align-items:center;justify-content:center}.v5q21{position:absolute;top:0;left:0;z-index:2}._1-CaQ{display:flex;align-items:center;box-sizing:border-box;height:1.5em;justify-content:center;min-width:1.5em;padding-left:.375em;padding-right:.375em;margin-left:-.0625em;margin-top:-.0625em}._3enaw{bottom:0;right:0}._3enaw,._15xcy{position:absolute;z-index:2}._15xcy{top:50%;left:0;display:flex;align-items:center;justify-content:center;width:100%;transform:translateY(-50%)}._19Xvt{position:absolute;left:50%;top:50%;transform:translate3d(-50%,-50%,0);perspective:1000;z-index:1}@media (-ms-high-contrast:none){._19Xvt{display:flex;justify-content:center;min-width:120px}}._31WnL._1ncNh ._19Xvt,._31WnL._3jIQr ._19Xvt,._31WnL.KuuiZ ._19Xvt,._31WnL:not(._3jIQr) ._1Dto9{display:none;visibility:hidden}._1RCw9{box-shadow:0 0 0 1px #c5c5c5;transition:transform .2s ease-out;will-change:transform}@media (hover:hover){._1RCw9:not(.KuuiZ):not(._3jIQr)._1ncNh:hover{transform:scale(1.12) translateZ(0) perspective(1px)}@supports (-ms-ime-align:auto){._1RCw9:not(.KuuiZ):not(._3jIQr)._1ncNh:hover{transform:scale(1.12) translateZ(0)}}}._1RCw9 ._1-CaQ,._1RCw9 ._19Xvt{color:#fff;display:flex}._1RCw9 ._19Xvt,._1RCw9:not(._1ncNh) ._1-CaQ{background-color:#c5c5c5}._1RCw9._1ncNh ._1-CaQ{background-color:#ff9000}._1RCw9 ._19Xvt{padding:.625em 1.25em}._1RCw9:not(.KuuiZ):not(._3jIQr):not(._1ncNh) ._1cTNw{opacity:.75}._1RCw9._1ncNh:not(.KuuiZ):not(._3jIQr){box-shadow:0 0 0 1px #ff9000}._1RCw9._3jIQr{box-shadow:none;border:1px dashed #c5c5c5}._1RCw9.KuuiZ{border-color:#d4d4d4}._1RCw9.KuuiZ ._1cTNw{width:8.125em;height:10.3125em}";
var styles$c = {"thumbnail":"_31WnL","thumbnail__body":"u0kNr","thumbnail__main":"_1cTNw","thumbnail__top-bar":"v5q21","thumbnail__counter":"_1-CaQ","thumbnail__bottom-bar":"_3enaw","thumbnail__middle-bar":"_15xcy","thumbnail__inactive-container":"_19Xvt","is-checked":"_1ncNh","is-loading":"_3jIQr","is-broken":"KuuiZ","thumbnail__loading-container":"_1Dto9","thumbnail--theme--primary":"_1RCw9"};
styleInject(css_248z$d);

var ThumbnailLayout = function ThumbnailLayout(_ref) {
  var _cx;

  var children = _ref.children,
      css = _ref.css,
      bottomBar = _ref.bottomBar,
      middleBar = _ref.middleBar,
      broken = _ref.broken,
      busy = _ref.busy,
      checked = _ref.checked,
      topBar = _ref.topBar;

  var mergedCSS = _objectSpread2({}, ThumbnailLayout.defaultProps.css, {}, css);

  var theme = mergedCSS.theme;
  var componentClassName = cx(styles$c.thumbnail, (_cx = {}, _defineProperty(_cx, styles$c["thumbnail--theme--".concat(theme)], theme), _defineProperty(_cx, styles$c['is-checked'], checked), _defineProperty(_cx, styles$c['is-loading'], busy), _defineProperty(_cx, styles$c['is-broken'], broken), _cx));
  return /*#__PURE__*/React.createElement("div", {
    className: componentClassName,
    "data-qa-tag": "page-thumbnail"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$c.thumbnail__body
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$c.thumbnail__main
  }, children), middleBar && /*#__PURE__*/React.createElement("div", {
    className: styles$c['thumbnail__middle-bar']
  }, middleBar), topBar && /*#__PURE__*/React.createElement("div", {
    className: styles$c['thumbnail__top-bar']
  }, topBar), bottomBar && /*#__PURE__*/React.createElement("div", {
    className: styles$c['thumbnail__bottom-bar']
  }, bottomBar)));
};

ThumbnailLayout.defaultProps = {
  busy: false,
  checked: true,
  broken: false,
  css: {
    theme: null
  },
  bottomBar: null,
  middleBar: null,
  topBar: null
};

var Thumbnail = function Thumbnail(_ref) {
  var children = _ref.children,
      broken = _ref.broken,
      busy = _ref.busy,
      checked = _ref.checked,
      bottomBar = _ref.bottomBar,
      css = _ref.css,
      middleBar = _ref.middleBar,
      topBar = _ref.topBar;

  var mergedCSS = _objectSpread2({}, Thumbnail.defaultProps.css, {}, css);

  return /*#__PURE__*/React.createElement(ThumbnailLayout, {
    bottomBar: bottomBar,
    css: mergedCSS,
    broken: broken,
    busy: busy,
    checked: checked,
    middleBar: middleBar,
    topBar: topBar
  }, children);
};

Thumbnail.defaultProps = {
  broken: false,
  busy: false,
  checked: true,
  css: {
    theme: 'primary'
  },
  bottomBar: null,
  middleBar: null,
  topBar: null
};

var LOADING_TEXT = constants.LOADING_TEXT;

var ThumbnailBusy = function ThumbnailBusy(_ref) {
  var children = _ref.children,
      css = _ref.css;

  var mergedCSS = _objectSpread2({}, ThumbnailBusy.defaultProps.css, {}, css);

  var theme = mergedCSS.theme;
  return /*#__PURE__*/React.createElement(ThumbnailLayout, {
    busy: true,
    theme: theme,
    middleBar: /*#__PURE__*/React.createElement(Text, {
      tagName: "div",
      color: "gray",
      value: "".concat(LOADING_TEXT, "..."),
      textAlign: "center",
      fontSize: "s"
    })
  }, children);
};

ThumbnailBusy.defaultProps = {
  css: {
    theme: 'primary'
  }
};

var ThumbnailCounter = function ThumbnailCounter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$c.thumbnail__counter
  }, children);
};

var ThumbnailBroken = function ThumbnailBroken(_ref) {
  var css = _ref.css;

  var mergedCSS = _objectSpread2({}, ThumbnailBroken.defaultProps.css, {}, css);

  return /*#__PURE__*/React.createElement(ThumbnailLayout, {
    broken: true,
    css: mergedCSS
  }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(DocumentBroken, {
    css: {
      width: '2xl',
      height: '2xl'
    }
  })))));
};

ThumbnailBroken.defaultProps = {
  css: {
    theme: 'primary'
  }
};

var ThumbnailInactiveContainer = function ThumbnailInactiveContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$c['thumbnail__inactive-container']
  }, children);
};

var ThumbnailLoadingContainer = function ThumbnailLoadingContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$c['thumbnail__loading-container']
  }, children);
};

var css_248z$e = ".X1_sa{position:absolute;top:-1000%;left:-1000%;right:-1000%;bottom:-1000%;margin:auto}.X1_sa.SCtkA{opacity:0}";
var styles$d = {"fields-layer":"X1_sa","is-hidden":"SCtkA"};
styleInject(css_248z$e);

var FieldLayerLayout = function FieldLayerLayout(_ref) {
  var children = _ref.children,
      hidden = _ref.hidden,
      height = _ref.height,
      scale = _ref.scale,
      width = _ref.width;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('field-layer-layout', styles$d['fields-layer'], _defineProperty({}, styles$d['is-hidden'], hidden)),
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px"),
      transform: "scale(".concat(scale, ")")
    }
  }, children);
};

FieldLayerLayout.defaultProps = {
  hidden: false
};

var css_248z$f = ".D93P5{position:absolute;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}._2nFiM,.D93P5{outline:none;display:flex}._2nFiM{width:100%;height:100%}.D93P5:focus{z-index:2;box-shadow:0 0 0 .125em #8acbff}._1J2AN{color:grey}._1J2AN:not(._2Ea18):not(._36NFH){background-color:rgba(255,144,0,.2)}@media (hover:hover){._1J2AN:not(._2Ea18):not(._36NFH):hover{background-color:rgba(255,144,0,.25)}}._1J2AN:not(._2Ea18):not(._36NFH):active{background-color:rgba(255,144,0,.3)}._1J2AN:not(._2Ea18):not(._36NFH).Etk2Q{box-shadow:0 0 0 .125em #ff9000}._1J2AN:not(._36NFH)._2Ea18{background-color:rgba(255,87,34,.2)}._1J2AN:not(._36NFH)._2Ea18:before{content:\"\\273D\";color:#e74c3c;position:absolute;top:.25em;left:.25em;font-size:.5em;line-height:1;pointer-events:none}@media (hover:hover){._1J2AN:not(._36NFH)._2Ea18:hover{background-color:rgba(255,87,34,.25)}}._1J2AN:not(._36NFH)._2Ea18:active{background-color:rgba(255,87,34,.3)}._1J2AN:not(._36NFH)._2Ea18.Etk2Q{box-shadow:0 0 0 2px #e15554}._1J2AN._36NFH{background-color:hsla(0,0%,66.7%,.2);color:#aaa;cursor:default}";
var styles$e = {"field-placeholder":"D93P5","field-placeholder__body":"_2nFiM","field-placeholder--theme--primary":"_1J2AN","is-required":"_2Ea18","is-locked":"_36NFH","is-focused":"Etk2Q"};
styleInject(css_248z$f);

var FieldPlaceholderLayout = function FieldPlaceholderLayout(_ref) {
  var _cx;

  var children = _ref.children,
      css = _ref.css,
      focused = _ref.focused,
      height = _ref.height,
      id = _ref.id,
      name = _ref.name,
      required = _ref.required,
      locked = _ref.locked,
      width = _ref.width,
      x = _ref.x,
      y = _ref.y,
      onClick = _ref.onClick;

  var mergedCSS = _objectSpread2({}, FieldPlaceholderLayout.defaultProps.css, {}, css);

  var theme = mergedCSS.theme,
      alignItems = mergedCSS.alignItems,
      justifyContent = mergedCSS.justifyContent;
  var componentClassName = cx(styles$e['field-placeholder'], (_cx = {}, _defineProperty(_cx, styles$e["field-placeholder--theme--".concat(theme)], theme), _defineProperty(_cx, styles$e['is-required'], required), _defineProperty(_cx, styles$e['is-focused'], focused), _defineProperty(_cx, styles$e['is-locked'], locked), _cx));
  var componentBodyClassName = cx(styles$e['field-placeholder__body'], globalClasses({
    alignItems: alignItems,
    justifyContent: justifyContent
  }));

  var handleClick = function handleClick() {
    onClick({
      height: height,
      id: id,
      name: name,
      required: required,
      locked: locked,
      width: width,
      x: x,
      y: y
    });
  };

  var handleKeyDown = function handleKeyDown(e) {
    // Simulate click on press Space
    if (e.key === ' ') {
      e.preventDefault();
      onClick({
        height: height,
        id: id,
        name: name,
        required: required,
        locked: locked,
        width: width,
        x: x,
        y: y
      });
    }
  };

  return (
    /*#__PURE__*/
    // TODO: Improve roles
    React.createElement("div", {
      id: id,
      "data-name": name,
      role: "textbox",
      className: componentClassName,
      tabIndex: locked ? -1 : 0,
      style: {
        top: "".concat(y, "px"),
        left: "".concat(x, "px"),
        height: "".concat(height, "px"),
        width: "".concat(width, "px")
      },
      onClick: handleClick,
      onKeyDown: handleKeyDown
    }, /*#__PURE__*/React.createElement("div", {
      className: componentBodyClassName,
      tabIndex: -1
    }, children))
  );
};

FieldPlaceholderLayout.defaultProps = {
  children: null,
  css: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  focused: false,
  required: false,
  locked: false,
  onClick: function onClick() {}
};

export { Button, Canvas, Checkbox, ControlPlaceholder, FieldLayerLayout, FieldPlaceholderLayout, Grid, Icon, Image, InfiniteProgress, Link, MemorizedScrollbar, PageListItem, PageListLayout, PreviewLayout, ProgressBar, Scrollbar, styles$5 as StylesMedia, Tab, Tabs, Text, Thumbnail, ThumbnailBroken, ThumbnailBusy, ThumbnailCounter, ThumbnailInactiveContainer, ThumbnailLoadingContainer, UploadingDocumentProgress, index as icons };
